import React, { useEffect, useState, useCallback } from 'react'
import styles from '../styles.module.scss'
import ScheduleTable from '../../../components/ScheduleTable'
import Modal from 'react-responsive-modal'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { useFormik } from 'formik'
import { Input, Textarea } from '../../../components/ModalInputs'
import Button from '../../../components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { getScheduleSettingsLessons } from '../../../actions/scheduleSettings'
import { getCourses, getTeachersList } from '../../../actions/common'
import { arrayForSelect } from '../../../utils/arrayForSelect'
import Select from '../../../components/Select'
import CustomSelect from '../../../components/CustomSelect'
import { getGroups } from '../../../actions/groups'
import { getRoomsList } from '../../../actions/rooms'
import Confirmation from '../../../components/Confirmation/Confirmation'


const status_lessons = [{ name: 'Обычное', id: 1 }, { name: 'Замена', id: 2 }, { name: 'Отмена', id: 3 }]

export default function Table() {

  const dispatch = useDispatch()

  const { data, loading } = useSelector(state => state.scheduling)


  const [editCell, setEditCell] = useState(null)

  useEffect(() => {
    dispatch(getCourses())
    dispatch(getTeachersList());
    dispatch(getGroups())
    dispatch(getRoomsList());
  }, [editCell])

  const handleCellDoubleClick = (cellData) => setEditCell(cellData)

  const closeModal = () => setEditCell(null)

  return (
    <div className={styles.wrapperTable}>

      <ScheduleTable
        schedule={data || []}
        loading={loading}
        onCellDoubleCLick={handleCellDoubleClick}
        handleExportToExcel={() => { }}
      />

      <EditModal
        open={!!editCell}
        data={editCell}
        closeModal={closeModal}
      />

    </div>
  )
}



const EditModal = ({ open, closeModal, data }) => {

  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmClose = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmClose = useCallback(() => setConfirmClose(false), [])

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeOnEsc={true}
      closeOnOverlayClick={true}
      showCloseIcon={false}
    >
      <Tabs>

        <TabList className={styles.tabsBlock}>
          {data?.map((_, ind) => <Tab className={styles.tab} selectedClassName={styles.activeTab}>{`Предмет ${ind + 1}`}</Tab>)}
        </TabList>

        {data?.map((course, ind) =>
          <TabPanel key={ind}>
            <CourseTab data={course} closeModal={closeModal} />
          </TabPanel>
        )}

      </Tabs>
      {confirmClose && (
        <Confirmation
          title="Закрыть без сохранения изменений?"
          acceptConfirmation={acceptConfirmClose}
          rejectConfirmation={rejectConfirmClose}
        />
      )}
    </Modal>
  )
}

const CourseTab = ({ data, closeModal }) => {

  const { courses, teachers } = useSelector(state => state.common)
  const { groupsEnd } = useSelector(state => state.groups);
  const { list } = useSelector(state => state.rooms)

  const [confirmation, setConfirmation] = useState(false);


  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue
  } = useFormik({
    initialValues: data,
    onSubmit: () => { }
  })

  const acceptConfirmation = () => {
    closeModal();
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  return (
    <form className={styles.courseForm} onSubmit={handleSubmit}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title="Закрыть без сохранения?"
          confirmation={confirmation}
          acceptConfirmation={() => acceptConfirmation(confirmation)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      <Input label='Класс' value={values.groupname} disabled />
      <Input label='Урок' value={`${values.periodname} (${values.periodtime})`} disabled />
      <CustomSelect
        title='Предмет'
        valuesName="act_types"
        value={values.act_types}
        setFieldValue={setFieldValue}
        options={arrayForSelect(courses, 'title', 'cid')} />
      <CustomSelect
        title='Класс / Подгруппа'
        valuesName="gid"
        value={values.gid}
        setFieldValue={setFieldValue}
        options={arrayForSelect(groupsEnd, 'name', 'gid')} />
      <CustomSelect
        title='Преподаватель'
        valuesName="teachermid"
        value={values.teachermid}
        setFieldValue={setFieldValue}
        options={arrayForSelect(teachers, 'calc_fio', 'mid')} />
      <CustomSelect
        title='Аудитория'
        valuesName="roomid"
        value={values.roomid}
        setFieldValue={setFieldValue}
        options={arrayForSelect(list, 'short_name', 'rid')} />
      {/* 'Статус занятия' === заполнен от руки */}
      <CustomSelect
        title='Статус занятия'
        valuesName="status_lessons"
        value={values.status_lessons}
        setFieldValue={setFieldValue}
        options={arrayForSelect(status_lessons, 'name', 'id')}
        withoutAll
      />
      <Textarea label='Примечание' />
      <div className={styles.buttonsBlock}>
        <Button>Сохранить</Button>
        <Button mode='white' onClick={() => setConfirmation(true)}>Отмена</Button>

      </div>
    </form>
  )
}